// extracted by mini-css-extract-plugin
export var block = "SocialShareBlock-module--block--d2e31";
export var component = "SocialShareBlock-module--component--1d59c";
export var fadePop = "SocialShareBlock-module--fade-pop--eab01";
export var growHeightIn = "SocialShareBlock-module--grow-height-in--f616d";
export var header = "SocialShareBlock-module--header--eab4f";
export var icon = "SocialShareBlock-module--icon--7d4fd";
export var icons = "SocialShareBlock-module--icons--644ea";
export var link = "SocialShareBlock-module--link--66d0e";